/*
  #301（2026-09-26 オーナー決定・B案）: 取り置いた本人・抽選に当選した人が、その品の商品ページから買う。
  ・ボタンは普通の商品と同じ「Add to cart」「Buy it now」の2つ。押したときの中身は会員ページの「購入」と同じ口
    （取り置き hold/purchase・当選品 raffle/purchase → その瞬間だけ在庫を戻して30分の窓 → /cart/add.js）
  ・本人かどうかは画面を開いた後にサーバーへ確かめる（hold/summary は本人の棚だけを返す）。
    Liquid には持ち主の手がかりを書かない。確かめられないときは何も出さない（今までどおり UNAVAILABLE）
  ・🛑 確かめるために購入の口を叩かない（書き込み＝在庫が戻り窓が開く）。押されたときだけ呼ぶ
  ・カートへの入れ方（422 のやり直し・/cart.js で確かめる）は nk-account.js の addPurchaseToCart と同じ作法
*/
(function (runtime) {
    "use strict";

    var HOLD_SUMMARY_PATH = "hold/summary";
    var HOLD_PURCHASE_PATH = "hold/purchase";
    var RAFFLE_PURCHASE_PATH = "raffle/purchase";
    var PURCHASE_TIMEOUT_MS = 15000;
    var CART_RETRY_ATTEMPTS = 6;
    var CART_RETRY_DELAY_MS = 600;
    var CART_RETRY_STEP_MS = 400;
    var CART_RETRY_MAX_DELAY_MS = 2000;
    var CART_RETRY_BUDGET_MS = 9000;
    // 断りの答え → 会員ページと同じ文言（nk.account.buy_result_*）
    var CODES = {
        unknown_hold: "UnknownHold", expired: "Expired", sold: "Sold",
        unavailable: "Unavailable", retry_later: "RetryLater", rate_limited: "RateLimited"
    };
    // この答えのあとは押し直しても変わらない＝ボタンを戻さない
    var FINAL_CODES = ["unknown_hold", "expired", "sold"];

    function text(root, name) {
        var value = root && root.dataset ? root.dataset[name] : "";
        return typeof value === "string" ? value : "";
    }

    function find(root, name) {
        return root.querySelector('[data-nk-own="' + name + '"]');
    }

    function wait(ms) {
        return new Promise(function (resolve) { runtime.setTimeout(resolve, ms); });
    }

    function own(object, key) {
        return Object.prototype.hasOwnProperty.call(object, key);
    }

    async function cartRequest(path, init) {
        var response = await runtime.fetch(path, Object.assign({credentials: "same-origin"}, init));
        if (!response.ok) {
            var error = new TypeError("カートの応答が不正です");
            error.status = response.status;
            throw error;
        }
        return response.json();
    }

    function cartContainsVariant(cart, variantId) {
        var items = cart && Array.isArray(cart.items) ? cart.items : [];
        return items.some(function (item) {
            return item && (String(item.variant_id) === variantId || String(item.id) === variantId);
        });
    }

    async function addToCart(urls, variantId) {
        // すでにカートに入っていれば足さない（Add to cart の後に Buy it now を押したとき、
        // 2個目の追加が「売り切れ」扱いになって待たされないように）
        try {
            var current = await cartRequest(urls.cart + ".js", {method: "GET", headers: {Accept: "application/json"}});
            if (cartContainsVariant(current, variantId)) { return; }
        } catch (error) {
            // 中身が読めなくても、足してみる（下で確かめる）
        }
        try {
            var payload = null;
            var startedAt = Date.now();
            for (var attempt = 1; attempt <= CART_RETRY_ATTEMPTS; attempt += 1) {
                try {
                    payload = await cartRequest(urls.add, {
                        method: "POST",
                        headers: {"Content-Type": "application/json", Accept: "application/json"},
                        body: JSON.stringify({items: [{id: Number(variantId), quantity: 1}]})
                    });
                    break;
                } catch (addError) {
                    // 在庫を戻した直後は売り場に届かず「売り切れ」（422）になることがある＝少し待ってやり直す
                    var remaining = CART_RETRY_BUDGET_MS - (Date.now() - startedAt);
                    if (addError && addError.status === 422 && attempt < CART_RETRY_ATTEMPTS && remaining > 0) {
                        await wait(Math.min(CART_RETRY_DELAY_MS + (attempt - 1) * CART_RETRY_STEP_MS,
                            CART_RETRY_MAX_DELAY_MS, remaining));
                        continue;
                    }
                    throw addError;
                }
            }
            if (!cartContainsVariant(payload, variantId)) {
                throw new TypeError("カートへの追加を確認できません");
            }
        } catch (error) {
            // 応答だけ失われた・すでに入っていた場合は、カートの中身で確かめる
            var cart = await cartRequest(urls.cart + ".js", {method: "GET", headers: {Accept: "application/json"}});
            if (!cartContainsVariant(cart, variantId)) {
                throw error;
            }
        }
    }

    /* 同じ操作の目印（冪等キー）。randomUUID の無い古い Safari でも作れるように */
    function operationKey() {
        var cryptoRef = runtime.crypto;
        if (cryptoRef && typeof cryptoRef.randomUUID === "function") { return cryptoRef.randomUUID(); }
        if (cryptoRef && typeof cryptoRef.getRandomValues === "function") {
            var bytes = cryptoRef.getRandomValues(new Uint8Array(16));
            return Array.prototype.map.call(bytes, function (b) { return (b + 256).toString(16).slice(1); }).join("");
        }
        return "";
    }

    /* 買う（1品）。{ok:true} か {ok:false, code}（code は CODES のどれか・分からなければ null） */
    async function buy(request, urls) {
        var proxy = runtime.NKAppProxy;
        var key = operationKey();
        if (!proxy || typeof proxy.post !== "function" || !key) {
            return {ok: false, code: null};
        }
        var result;
        try {
            result = await proxy.post(request.path, {
                body: request.body, idempotencyKey: key, timeoutMs: PURCHASE_TIMEOUT_MS
            });
        } catch (error) {
            var status = error && error.status;
            return {ok: false, code: status === 429 ? "rate_limited" : null};
        }
        var objectResult = result && typeof result === "object" && !Array.isArray(result);
        if (objectResult && result.ok === true && !result.code
                && typeof result.variant_id === "string" && /^[1-9][0-9]*$/.test(result.variant_id)) {
            try {
                await addToCart(urls, result.variant_id);
            } catch (error) {
                return {ok: false, code: null};
            }
            return {ok: true};
        }
        var code = objectResult && result.ok === false && typeof result.code === "string"
            && own(CODES, result.code) ? result.code : null;
        return {ok: false, code: code};
    }

    function openCart(mode, urls) {
        // 「Add to cart」はカートの引き出しを開いて買い物を続けられるように（引き出しが無い設定ならカートの画面へ）
        if (mode === "add" && runtime.document.getElementById("CartDrawer")) {
            runtime.document.dispatchEvent(new CustomEvent("cart:build"));
            runtime.document.dispatchEvent(new CustomEvent("cart:open"));
            return;
        }
        runtime.location.assign(urls.cart);
    }

    /* 2つのボタンを1つの品の買う口につなぐ。request() は {path, body} を返す */
    function bind(box, request) {
        if (!box || box.dataset.nkOwnBound === "1") {
            return;
        }
        box.dataset.nkOwnBound = "1";
        var add = find(box, "add");
        var now = find(box, "now");
        var status = find(box, "status");
        var account = find(box, "account");
        var urls = {
            cart: text(box, "nkOwnCartUrl") || "/cart",
            add: text(box, "nkOwnCartAddUrl") || "/cart/add.js"
        };
        var busy = false;
        function say(message) {
            if (!status) { return; }
            status.textContent = message;
            status.hidden = !message;
        }
        async function press(mode) {
            if (busy) { return; }  // 連打しても1回だけ
            busy = true;
            add.disabled = true;
            now.disabled = true;
            say(text(box, "nkOwnWorking"));
            var outcome = await buy(request(), urls);
            if (outcome.ok) {
                say(text(box, "nkOwnAdded"));
                if (account) { account.hidden = true; }
                busy = false;
                add.disabled = false;
                now.disabled = false;
                openCart(mode, urls);
                return;
            }
            say(text(box, "nkOwnResult" + (outcome.code ? CODES[outcome.code] : "NoAnswer")));
            // 「予約を確かめて」「もう取り置きではない」と言うときは、確かめる場所（会員ページ）を添える
            if (account) { account.hidden = !(outcome.code === null || outcome.code === "unknown_hold" || outcome.code === "expired"); }
            busy = false;
            var final = FINAL_CODES.indexOf(outcome.code) !== -1;
            add.disabled = final;
            now.disabled = final;
        }
        // 押した処理の終わりを返す（画面の動きは同じ・検査が結果を待てるように）
        add.addEventListener("click", function () { return press("add"); });
        now.addEventListener("click", function () { return press("now"); });
    }

    function handleOf(url) {
        var match = typeof url === "string" ? /\/products\/([^/?#]+)/.exec(url) : null;
        return match ? decodeURIComponent(match[1]) : "";
    }

    function dueText(locale, iso) {
        var at = Date.parse(iso);
        if (!Number.isFinite(at)) { return ""; }
        try {
            return new Intl.DateTimeFormat(locale || undefined, {weekday: "short", month: "short", day: "numeric"})
                .format(new Date(at));
        } catch (error) {
            return new Date(at).toISOString().slice(0, 10);
        }
    }

    /* 取り置き中の商品ページ: 本人の取り置きなら UNAVAILABLE の代わりに2つのボタン */
    async function initHold(box) {
        if (box.dataset.nkOwnChecked === "1") { return; }
        box.dataset.nkOwnChecked = "1";
        var proxy = runtime.NKAppProxy;
        if (!proxy || typeof proxy.get !== "function") { return; }
        var payload;
        try {
            // 失敗しても今までどおり UNAVAILABLE なだけ＝やり直さない（混雑時に購入の枠を食わない）
            payload = await proxy.get(HOLD_SUMMARY_PATH, {retry: false});
        } catch (error) {
            return;  // 関所が閉・未ログイン・通信失敗＝今までどおり UNAVAILABLE のまま
        }
        var shelf = payload && payload.ok === true && Array.isArray(payload.shelf) ? payload.shelf : [];
        var productId = text(box, "nkOwnProductId");
        var handle = text(box, "nkOwnHandle");
        var mine = shelf.filter(function (item) {
            if (!item || typeof item !== "object" || item.won === true || typeof item.id !== "string") { return false; }
            // 番号を先に見る（サーバーが出していれば）。無ければ商品のアドレスで照合する
            if (typeof item.product_id === "string" && item.product_id) { return item.product_id === productId; }
            return handle !== "" && handleOf(item.url) === handle;
        })[0];
        if (!mine) { return; }
        var due = find(box, "due");
        if (due) {
            var label = dueText(text(box, "nkOwnLocale"), mine.due_at);
            due.textContent = label ? text(box, "nkOwnChip").replace("{date}", label) : text(box, "nkOwnChipNoDate");
        }
        // UNAVAILABLE の案内・写真の暗幕・「戻ったら知らせて」を、本人の画面だけ外す
        var notice = box.closest(".nk-reserved-notice");
        if (notice) { notice.classList.add("is-own"); }
        var scope = box.closest("[data-product-id], .product-section, .product-single, section") || runtime.document;
        // 🛑 同じ根元の中に「似た作品・最近見た品」などの棚があり、ほかの品のカードも is-reserved を持つ。
        //    外すのはこの品の写真の器だけ（棚の中は除く）。印が根元そのものに付く型もあるので根元も見る
        var targets = Array.prototype.slice.call(scope.querySelectorAll(".is-reserved, .nk-product-reserved"));
        if (scope.classList && (scope.classList.contains("is-reserved") || scope.classList.contains("nk-product-reserved"))) {
            targets.push(scope);
        }
        targets.forEach(function (node) {
            if (node !== scope && typeof node.closest === "function"
                    && node.closest("[data-nk-product-shelf], [data-nk-product-shelves]")) { return; }
            node.classList.remove("is-reserved");
            node.classList.remove("nk-product-reserved");
        });
        Array.prototype.forEach.call(scope.querySelectorAll(".nk-up--restock"), function (node) {
            node.hidden = true;
        });
        box.hidden = false;
        bind(box, function () { return {path: HOLD_PURCHASE_PATH, body: {id: mine.id}}; });
    }

    function autoInit() {
        Array.prototype.forEach.call(runtime.document.querySelectorAll("[data-nk-own-hold]"), function (box) {
            initHold(box);
        });
    }

    var api = {bind: bind, buy: buy, autoInit: autoInit, rafflePath: RAFFLE_PURCHASE_PATH,
        _handleOf: handleOf, _cartContainsVariant: cartContainsVariant};
    runtime.NKOwnPurchase = api;
    if (runtime.document) {
        if (runtime.document.readyState === "loading") {
            runtime.document.addEventListener("DOMContentLoaded", autoInit);
        } else {
            autoInit();
        }
        // 戻る（ページの記憶から復元）でも、同じ画面のまま押せるように
        runtime.addEventListener("pageshow", function (event) { if (event.persisted) { autoInit(); } });
    }
    if (typeof module === "object" && module && module.exports) {
        module.exports = api;
    }
})(typeof window !== "undefined" ? window : globalThis);
